import React from "react"
import ReactNative from "react-native"
import Device from "app/lib/Device"
import FS from "app/components/FS"
import ChallengeStat from "app/components/ChallengeStat"

import { colors } from "app/lib/styles"

const { View, StyleSheet, InteractionManager } = ReactNative

export default class ChallengeStats extends React.Component {
  static defaultProps = {
    tintColor: colors.challengeBlue,
  }

  constructor(props) {
    super(props)
  }

  renderStat(topLabel, value, bottomLabel, isPercent = false) {
    if (isPercent) {
      value = `${Math.round(value)}`
    }

    return (
      <ChallengeStat
        topLabel={topLabel}
        bottomLabel={bottomLabel}
        value={value}
        isPercent={isPercent}
        tintColor={this.props.tintColor}
      />
    )
  }

  render() {
    var stats = this.props.stats
    if (!stats) {
      return <View />
    }

    return (
      <View style={[styles.container, this.props.style]}>
        {this.renderStat("STREAK", stats.streak_days, "DAYS")}
        {this.renderStat("TOTAL", stats.total_active_days, "DAYS")}
        {this.renderStat(
          "SUCCESS",
          stats.percent_successfull_checkins
            ? stats.percent_successfull_checkins
            : stats.percent_successfull_days,
          "RATE",
          true
        )}
      </View>
    )
  }
}

var styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
})
